import type { AxiosInstance } from 'axios';
import type { CastorPartStatus, CastorSession } from '@accio3d/shared/domain';

/**
 * Builds the client for Castor analysis status and Castor viewer sessions.
 * @param client the authenticated API client
 * @returns the service reading part statuses and minting Castor sessions
 */
export function createCastorProjectsService(client: AxiosInstance) {
  return {
    statuses: async (partIds: string[]): Promise<CastorPartStatus[]> => {
      const { data } = await client.get<CastorPartStatus[]>('/castor-projects/parts/status', {
        params: { partIds: partIds.join(',') },
      });
      return data;
    },
    openSession: async (partId: string, sessionId?: string): Promise<CastorSession> => {
      const { data } = await client.post<CastorSession>(
        `/parts/${partId}/castor-session`,
        sessionId ? { sessionId } : {},
      );
      return data;
    },
  };
}

export type CastorProjectsService = ReturnType<typeof createCastorProjectsService>;
